import { render, staticRenderFns } from "./VendorProjectHistory.vue?vue&type=template&id=1d2c0313&"
import script from "./VendorProjectHistory.vue?vue&type=script&lang=js&"
export * from "./VendorProjectHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports